<template>
    <div class="main">
        <div class="sectionContacts">
            <div class="containerWrapper">
                <div class="container">
                    <div class="content">
                        <template v-for="(contact, index) in all">
                            <component :is="getComponent(contact)"
                                       :key="contact.name"
                                       :contact="contact"
                                       :delay="500*(index + 1)"
                            ></component>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import {menusMixin} from "../mixins/menus";
    import {menusNames as mn,} from "../constants/menus";

    export default {
        mixins: [menusMixin],
        data() {
            return {
                mapShown: false,
            }
        },
        computed: {
            ...mapGetters('contacts', {
                contacts: 'all',
            }),
            all() {
                return this.contacts.filter((contact) => {
                    return ['ABOUT US', 'STUDIO'].indexOf(contact.name) === -1
                })
            },
        },
        created() {
        },
        mounted() {
            this.setSeo(this.$_getMenuSeo(mn.CONTACT))
        },
        watch: {},
        methods: {
            ...mapActions('ui', {
                'setSeo': 'setSeo',
            }),
            getComponent(contact) {
                if (contact.type === 'portfolio' && contact.section && contact.section.length) {
                    return 'ContactList'
                } else if (contact.type === 'text' && contact.content && contact.content.length) {
                    return 'ContactText'
                } else if (contact.type === 'portfolio' && contact.id === 'MAP') {
                    return 'ContactMap'
                } else if (contact.type === 'portfolio' && contact.content && contact.content.length) {
                    return 'ContactImageList'
                }
            },
            onMapShown() {
                this.mapShown = true
            }
        }
    }
</script>
